import React from 'react';
import { Box, SvgIcon } from '@material-ui/core';
import {
  HomeCardContainer,
  HomeCardImageLink,
  HomeCardTitle,
  HomeCardDescription,
  HomeCardLinks,
  HomeCardLink,
} from './HomeStyles';
import DocsIcon from '../icons/DocsIcon';

interface HomeCardProps {
  title: string;
  description?: string;
  icon?: () => React.JSX.Element;
  href?: string;
  links?: { label: string; url: string }[];
}

export const HomeCard = ({
  title,
  description,
  icon,
  href,
  links,
}: HomeCardProps) => {
  return (
    <HomeCardContainer>
      {href && icon && (
        <HomeCardImageLink to={href}>
          <SvgIcon component={icon} />
        </HomeCardImageLink>
      )}

      <Box sx={{ display: 'flex', flexDirection: 'column', gridRowGap: '8px' }}>
        <HomeCardTitle variant="h3">{title}</HomeCardTitle>
        {description && (
          <HomeCardDescription variant="subtitle2">
            {description}
          </HomeCardDescription>
        )}

        {links && links.length > 0 && (
          <HomeCardLinks>
            {links.map(link => (
              <HomeCardLink key={link.label} to={link.url}>
                <DocsIcon styles={{ fontSize: '20px', color: '#000' }} />
                {link.label}
              </HomeCardLink>
            ))}
          </HomeCardLinks>
        )}
      </Box>
    </HomeCardContainer>
  );
};
